import { Injectable } from '@angular/core';
import { filter, firstValueFrom, map, Observable, take } from 'rxjs';
import { CurrentInfo, CurrentInfoService } from '../current';
import { ProducerSummary } from '../producers';
import { ControllerUser, ProducerUser, User } from './user';
import { ControllerSummary } from '../controllers';
import { AuthService, InitialSyncService } from '@homeleite/arch';

@Injectable({ providedIn: 'root' })
export class CurrentUserService {
    public readonly $user: Observable<User>;

    constructor(
        currentInfo: CurrentInfoService,
        private authService: AuthService,
        private initialSyncService: InitialSyncService
    ) {
        this.$user = currentInfo.$value.pipe(
            filter((it: CurrentInfo) => it != null),
            map((it: CurrentInfo) => it.user)
        );
    }

    async getProducer(): Promise<ProducerSummary | null> {
        return firstValueFrom(
            this.$user.pipe(
                take(1),
                map((it) => (it instanceof ProducerUser) ? it.producer : null)
            )
        );
    }

    async getController(): Promise<ControllerSummary> {
        return await firstValueFrom(
            this.$user.pipe(
                take(1),
                map((it) => (it instanceof ControllerUser) ? it.controller : null)
            )
        );
    }

    async logout(): Promise<void> {
        this.authService.publishLogout();
        this.initialSyncService.resetSyncFlag();
    }
}
